// Übersetzungen für die Filter-/Sortierleiste der Transfer-Listen (lf_*).
// Schlüssel: flach; Admin-Overrides aus der DB haben weiterhin Vorrang.
const de = {
  lf_search_placeholder: "Suche: Buchungsnr., Name, Telefon, Adresse …",
  lf_kpi_count: "Transfers",
  lf_kpi_revenue: "Umsatz",
  lf_kpi_revenue_hint: "Umsatz der Auswahl ohne stornierte Buchungen",
  lf_kpi_cash: "davon Bar",
  lf_kpi_card: "davon Karte",
  lf_kpi_paypal: "davon PayPal",
  lf_kpi_open: "davon unbezahlt",
  lf_next_pickup_in: "Nächste Abholung in",
  lf_unit_d: "T",
  lf_unit_h: "Std",
  lf_unit_min: "Min",
  lf_time_label: "Zeitraum",
  lf_time_all: "Alle",
  lf_time_upcoming: "Anstehend",
  lf_time_today: "Heute",
  lf_time_tomorrow: "Morgen",
  lf_time_week: "Diese Woche",
  lf_time_past: "Vergangen",
  lf_time_range: "Zeitraum wählen",
  lf_date_from: "Von",
  lf_date_to: "Bis",
  lf_attn_label: "Handlungsbedarf",
  lf_attn_no_driver: "Ohne Fahrer",
  lf_attn_urgent: "Abholung < 24 h ohne Fahrer",
  lf_attn_payment_open: "Zahlung offen",
  lf_attn_offer_open: "Angebot beantworten",
  lf_attn_counter_open: "Gegenangebot offen",
  lf_attn_complained: "Reklamation",
  lf_status_label: "Status",
  lf_status_new: "Neu / geplant",
  lf_status_confirmed: "Bestätigt / zugewiesen",
  lf_status_active: "Unterwegs",
  lf_status_completed: "Abgeschlossen",
  lf_status_cancelled: "Storniert",
  lf_status_noshow: "Nicht angetroffen",
  lf_status_complained: "Reklamiert",
  lf_pay_label: "Zahlungsart",
  lf_pay_cash: "Bar",
  lf_pay_cardontrip: "Karte im Fahrzeug",
  lf_pay_card: "Online (Karte)",
  lf_pay_paypal: "PayPal",
  lf_pay_other: "Sonstige",
  lf_pstat_label: "Zahlungsstatus",
  lf_pstat_paid: "Bezahlt",
  lf_pstat_open: "Offen",
  lf_sort_label: "Sortieren nach",
  lf_sort_pickup_asc: "Abholzeit: nächste zuerst",
  lf_sort_pickup_desc: "Abholzeit: späteste zuerst",
  lf_sort_created_desc: "Buchungsdatum: neueste zuerst",
  lf_sort_created_asc: "Buchungsdatum: älteste zuerst",
  lf_sort_price_desc: "Preis: höchster zuerst",
  lf_sort_price_asc: "Preis: niedrigster zuerst",
  lf_sort_status_asc: "Status: Handlungsbedarf zuerst",
  lf_reset: "Zurücksetzen",
  lf_active_filters: "aktive Filter",
  lf_hidden_by_filter: "Transfers durch Filter ausgeblendet",
  lf_toggle_payment: "Zahlung",
  lf_load_error: "Daten konnten nicht geladen werden",
};
const en = {
  lf_search_placeholder: "Search: booking no., name, phone, address …",
  lf_kpi_count: "Transfers",
  lf_kpi_revenue: "Revenue",
  lf_kpi_revenue_hint: "Revenue of the selection, excluding cancelled bookings",
  lf_kpi_cash: "of which cash",
  lf_kpi_card: "of which card",
  lf_kpi_paypal: "of which PayPal",
  lf_kpi_open: "of which unpaid",
  lf_next_pickup_in: "Next pickup in",
  lf_unit_d: "d",
  lf_unit_h: "h",
  lf_unit_min: "min",
  lf_time_label: "Period",
  lf_time_all: "All",
  lf_time_upcoming: "Upcoming",
  lf_time_today: "Today",
  lf_time_tomorrow: "Tomorrow",
  lf_time_week: "This week",
  lf_time_past: "Past",
  lf_time_range: "Pick date range",
  lf_date_from: "From",
  lf_date_to: "To",
  lf_attn_label: "Needs action",
  lf_attn_no_driver: "No driver",
  lf_attn_urgent: "Pickup < 24 h without driver",
  lf_attn_payment_open: "Payment open",
  lf_attn_offer_open: "Answer offer",
  lf_attn_counter_open: "Counter offer pending",
  lf_attn_complained: "Complaint",
  lf_status_label: "Status",
  lf_status_new: "New / planned",
  lf_status_confirmed: "Confirmed / assigned",
  lf_status_active: "On the way",
  lf_status_completed: "Completed",
  lf_status_cancelled: "Cancelled",
  lf_status_noshow: "No-show",
  lf_status_complained: "Complained",
  lf_pay_label: "Payment method",
  lf_pay_cash: "Cash",
  lf_pay_cardontrip: "Card in vehicle",
  lf_pay_card: "Online (card)",
  lf_pay_paypal: "PayPal",
  lf_pay_other: "Other",
  lf_pstat_label: "Payment status",
  lf_pstat_paid: "Paid",
  lf_pstat_open: "Open",
  lf_sort_label: "Sort by",
  lf_sort_pickup_asc: "Pickup time: soonest first",
  lf_sort_pickup_desc: "Pickup time: latest first",
  lf_sort_created_desc: "Booking date: newest first",
  lf_sort_created_asc: "Booking date: oldest first",
  lf_sort_price_desc: "Price: highest first",
  lf_sort_price_asc: "Price: lowest first",
  lf_sort_status_asc: "Status: needs action first",
  lf_reset: "Reset",
  lf_active_filters: "active filters",
  lf_hidden_by_filter: "transfers hidden by filters",
  lf_toggle_payment: "Payment",
  lf_load_error: "Data could not be loaded",
};
const tr = {
  lf_search_placeholder: "Ara: rezervasyon no, ad, telefon, adres …",
  lf_kpi_count: "Transfer",
  lf_kpi_revenue: "Ciro",
  lf_kpi_revenue_hint: "Seçimin cirosu (iptal edilen rezervasyonlar hariç)",
  lf_kpi_cash: "bunun nakit",
  lf_kpi_card: "bunun kart",
  lf_kpi_paypal: "bunun PayPal",
  lf_kpi_open: "bunun ödenmemiş",
  lf_next_pickup_in: "Sonraki alım şu kadar sonra",
  lf_unit_d: "g",
  lf_unit_h: "sa",
  lf_unit_min: "dk",
  lf_time_label: "Zaman aralığı",
  lf_time_all: "Tümü",
  lf_time_upcoming: "Yaklaşan",
  lf_time_today: "Bugün",
  lf_time_tomorrow: "Yarın",
  lf_time_week: "Bu hafta",
  lf_time_past: "Geçmiş",
  lf_time_range: "Tarih aralığı seç",
  lf_date_from: "Başlangıç",
  lf_date_to: "Bitiş",
  lf_attn_label: "İşlem gerekli",
  lf_attn_no_driver: "Şoförsüz",
  lf_attn_urgent: "24 saatten kısa sürede şoförsüz alım",
  lf_attn_payment_open: "Ödeme açık",
  lf_attn_offer_open: "Teklifi yanıtla",
  lf_attn_counter_open: "Karşı teklif bekliyor",
  lf_attn_complained: "Şikayet",
  lf_status_label: "Durum",
  lf_status_new: "Yeni / planlanan",
  lf_status_confirmed: "Onaylandı / atandı",
  lf_status_active: "Yolda",
  lf_status_completed: "Tamamlandı",
  lf_status_cancelled: "İptal edildi",
  lf_status_noshow: "Müşteri gelmedi",
  lf_status_complained: "Şikayet edildi",
  lf_pay_label: "Ödeme yöntemi",
  lf_pay_cash: "Nakit",
  lf_pay_cardontrip: "Araçta kart",
  lf_pay_card: "Online (kart)",
  lf_pay_paypal: "PayPal",
  lf_pay_other: "Diğer",
  lf_pstat_label: "Ödeme durumu",
  lf_pstat_paid: "Ödendi",
  lf_pstat_open: "Açık",
  lf_sort_label: "Sırala",
  lf_sort_pickup_asc: "Alım saati: en yakın önce",
  lf_sort_pickup_desc: "Alım saati: en geç önce",
  lf_sort_created_desc: "Rezervasyon tarihi: en yeni önce",
  lf_sort_created_asc: "Rezervasyon tarihi: en eski önce",
  lf_sort_price_desc: "Fiyat: en yüksek önce",
  lf_sort_price_asc: "Fiyat: en düşük önce",
  lf_sort_status_asc: "Durum: işlem gerekenler önce",
  lf_reset: "Sıfırla",
  lf_active_filters: "aktif filtre",
  lf_hidden_by_filter: "transfer filtreler nedeniyle gizlendi",
  lf_toggle_payment: "Ödeme",
  lf_load_error: "Veriler yüklenemedi",
};
const pl = {
  lf_search_placeholder: "Szukaj: nr rezerwacji, nazwisko, telefon, adres …",
  lf_kpi_count: "Transfery",
  lf_kpi_revenue: "Przychód",
  lf_kpi_revenue_hint: "Przychód wybranych rezerwacji bez anulowanych",
  lf_kpi_cash: "w tym gotówka",
  lf_kpi_card: "w tym karta",
  lf_kpi_paypal: "w tym PayPal",
  lf_kpi_open: "w tym nieopłacone",
  lf_next_pickup_in: "Najbliższy odbiór za",
  lf_unit_d: "d",
  lf_unit_h: "godz.",
  lf_unit_min: "min",
  lf_time_label: "Okres",
  lf_time_all: "Wszystkie",
  lf_time_upcoming: "Nadchodzące",
  lf_time_today: "Dziś",
  lf_time_tomorrow: "Jutro",
  lf_time_week: "Ten tydzień",
  lf_time_past: "Minione",
  lf_time_range: "Wybierz zakres dat",
  lf_date_from: "Od",
  lf_date_to: "Do",
  lf_attn_label: "Wymaga działania",
  lf_attn_no_driver: "Bez kierowcy",
  lf_attn_urgent: "Odbiór < 24 h bez kierowcy",
  lf_attn_payment_open: "Płatność otwarta",
  lf_attn_offer_open: "Odpowiedz na ofertę",
  lf_attn_counter_open: "Kontroferta oczekuje",
  lf_attn_complained: "Reklamacja",
  lf_status_label: "Status",
  lf_status_new: "Nowe / zaplanowane",
  lf_status_confirmed: "Potwierdzone / przypisane",
  lf_status_active: "W drodze",
  lf_status_completed: "Zakończone",
  lf_status_cancelled: "Anulowane",
  lf_status_noshow: "Nieobecność klienta",
  lf_status_complained: "Reklamowane",
  lf_pay_label: "Metoda płatności",
  lf_pay_cash: "Gotówka",
  lf_pay_cardontrip: "Karta w pojeździe",
  lf_pay_card: "Online (karta)",
  lf_pay_paypal: "PayPal",
  lf_pay_other: "Inne",
  lf_pstat_label: "Status płatności",
  lf_pstat_paid: "Opłacone",
  lf_pstat_open: "Otwarte",
  lf_sort_label: "Sortuj wg",
  lf_sort_pickup_asc: "Czas odbioru: najbliższe najpierw",
  lf_sort_pickup_desc: "Czas odbioru: najpóźniejsze najpierw",
  lf_sort_created_desc: "Data rezerwacji: najnowsze najpierw",
  lf_sort_created_asc: "Data rezerwacji: najstarsze najpierw",
  lf_sort_price_desc: "Cena: najwyższa najpierw",
  lf_sort_price_asc: "Cena: najniższa najpierw",
  lf_sort_status_asc: "Status: wymagające działania najpierw",
  lf_reset: "Resetuj",
  lf_active_filters: "aktywne filtry",
  lf_hidden_by_filter: "transfery ukryte przez filtry",
  lf_toggle_payment: "Płatność",
  lf_load_error: "Nie udało się załadować danych",
};
const uk = {
  lf_search_placeholder: "Пошук: № бронювання, ім’я, телефон, адреса …",
  lf_kpi_count: "Трансфери",
  lf_kpi_revenue: "Дохід",
  lf_kpi_revenue_hint: "Дохід вибраних бронювань без скасованих",
  lf_kpi_cash: "з них готівка",
  lf_kpi_card: "з них картка",
  lf_kpi_paypal: "з них PayPal",
  lf_kpi_open: "з них неоплачено",
  lf_next_pickup_in: "Найближче подання через",
  lf_unit_d: "д",
  lf_unit_h: "год",
  lf_unit_min: "хв",
  lf_time_label: "Період",
  lf_time_all: "Усі",
  lf_time_upcoming: "Майбутні",
  lf_time_today: "Сьогодні",
  lf_time_tomorrow: "Завтра",
  lf_time_week: "Цього тижня",
  lf_time_past: "Минулі",
  lf_time_range: "Обрати діапазон дат",
  lf_date_from: "Від",
  lf_date_to: "До",
  lf_attn_label: "Потрібна дія",
  lf_attn_no_driver: "Без водія",
  lf_attn_urgent: "Подача < 24 год без водія",
  lf_attn_payment_open: "Оплата відкрита",
  lf_attn_offer_open: "Відповісти на пропозицію",
  lf_attn_counter_open: "Зустрічна пропозиція очікує",
  lf_attn_complained: "Рекламація",
  lf_status_label: "Статус",
  lf_status_new: "Нові / заплановані",
  lf_status_confirmed: "Підтверджені / призначені",
  lf_status_active: "В дорозі",
  lf_status_completed: "Завершені",
  lf_status_cancelled: "Скасовані",
  lf_status_noshow: "Клієнт не з’явився",
  lf_status_complained: "Рекламовані",
  lf_pay_label: "Спосіб оплати",
  lf_pay_cash: "Готівка",
  lf_pay_cardontrip: "Картка в авто",
  lf_pay_card: "Онлайн (картка)",
  lf_pay_paypal: "PayPal",
  lf_pay_other: "Інше",
  lf_pstat_label: "Статус оплати",
  lf_pstat_paid: "Оплачено",
  lf_pstat_open: "Відкрито",
  lf_sort_label: "Сортувати за",
  lf_sort_pickup_asc: "Час подачі: найближчі спочатку",
  lf_sort_pickup_desc: "Час подачі: найпізніші спочатку",
  lf_sort_created_desc: "Дата бронювання: найновіші спочатку",
  lf_sort_created_asc: "Дата бронювання: найстаріші спочатку",
  lf_sort_price_desc: "Ціна: найвища спочатку",
  lf_sort_price_asc: "Ціна: найнижча спочатку",
  lf_sort_status_asc: "Статус: що потребує дії спочатку",
  lf_reset: "Скинути",
  lf_active_filters: "активні фільтри",
  lf_hidden_by_filter: "трансферів приховано фільтрами",
  lf_toggle_payment: "Оплата",
  lf_load_error: "Не вдалося завантажити дані",
};
const listFilters = { de, en, tr, pl, uk };
export default listFilters;
